import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Loader } from '@grandvisionhq/common';
import { useGetProductsBySku } from '../../utils/use-get-products-by-sku.js';
import { CommerceToolsProductBlock } from './CommerceTools.js';

const ProductBlocksContainer = ({ skus =[] , limit , staticsUrl , formatProductUrl , className , reimbursableLogos  })=>{
    const { products , isLoading  } = useGetProductsBySku(skus, limit);
    const classNames = classnames('product-blocks-container', {
        className,
        loading: isLoading
    });
    const productBlockProps = React.useMemo(()=>({
            staticsUrl,
            formatProductUrl,
            reimbursableLogos,
            showVariants: true
        })
    , [
        staticsUrl,
        formatProductUrl
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames
    }, isLoading ? /*#__PURE__*/ React.createElement(Loader, null) : products.map((product)=>/*#__PURE__*/ React.createElement(CommerceToolsProductBlock, swcHelpers.extends({
            key: product.id,
            product: product
        }, productBlockProps))
    ));
};
var ProductBlocksContainer$1 = ProductBlocksContainer;

export { ProductBlocksContainer, ProductBlocksContainer$1 as default };
//# sourceMappingURL=ProductBlocksContainer.js.map
